export class State<T> {
  error: Record<string, any> | null = null;
  success = false;
  isLoading = false;
  dataList: Array<T> = [];
  total = 0;
}
